<template lang="pug">
    section#economia
        div.wrapper
            h2
                |VEJA COMO VOCÊ ECONOMIZA AO
                |TRANSFERIR SEU CURSO PARA A UniFAEL:
            div.economia
                div.table
                    h3 FACULDADE “A”: Presencial
                    div.header
                        p FACULDADE
                        p mensalidade
                        p
                            |INVESTIMENTO
                            br
                            |TOTAL
                    div.body
                        p
                            |Faculdade “A”
                            |(presencial)
                        p R$639,00
                        p R$30.672,00
                    div.body
                        p
                            |FAEL
                            br
                            |(a distância)
                        p R$167,90
                        p R$8.059,23
                    div.total
                        p
                            |TOTAL
                            br
                            |ECONOMIZADO
                        p R$471,10
                        p R$22.612,77
                    div.textolegal
                        span
                            |Exemplo Curso de ADMINISTRAÇÃO valores base ingresso Vestibular Verão/20, para início 1º Semestre de 2020 sem considerar reajustes.Valor do curso para pagamento até o dia 5 de cada mês.

                div.table
                    h3 FACULDADE “B”: EAD
                    div.header
                        p FACULDADE
                        p mensalidade
                        p
                            |INVESTIMENTO
                            br
                            |TOTAL
                    div.body
                        p
                            |Faculdade “B”
                            br
                            |(a distância)
                        p R$430,00
                        p R$20.640,00
                    div.body
                        p
                            |FAEL
                            br
                            |(a distância)
                        p R$167,90
                        p R$8.059,23
                    div.total
                        p
                            |TOTAL
                            br
                            |ECONOMIZADO
                        p R$262,10
                        p R$12.580,77
                    div.textolegal
                        span
                            |Exemplo Curso de ADMINISTRAÇÃO valores base ingresso Vestibular Verão/20, para início 1º Semestre de 2020 sem considerar reajustes.Valor do curso para pagamento até o dia 5 de cada mês.
</template>

<script>
export default {
    name: "section-economia"
}
</script>

<style lang="stylus" scoped src="./Economia.styl"></style>
